import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import { Button, Chip, Dialog, DialogActions, DialogContent, Divider, Grid, LinearProgress, List, ListItem, ListItemText, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRole, fetchPermissions, fetchRoleData } from '../../store/roleSlice';
import RoleForm from '../roles/RoleForm';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ADD_UPDATE, capitalizeWords, FULL_ACCESS, MODULE_ADD, MODULE_CHANGE, MODULE_PERMISSIONS, MODULE_VIEW, ROWS_PER_PAGE, VIEW_ONLY } from '../../utils/constant';
import Loader from '../Common/Loader';
import Confirmation from '../Common/Confirmation';
import { Link } from 'react-router-dom';
import BasicPopover from '../Common/PopOver';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { NoData } from '../Common/NoData';

function createData(id, name, permissions, actions) {
  return {
    id,
    name,
    permissions,
    actions
  };
}

const RoleActions = ({ getRoles, setPage, setRoleModal, role, setSelectedRole }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dispatch = useDispatch()
  const handleDelete = async (id) => {
    try {
      dispatch(deleteRole(id)).then(() => {
        // setPage(0)
        getRoles()
      })
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <Grid spacing={4} justifyContent={'flex-end'}>
        <Grid size={8}>
          <Box gap={2} display='flex' className="table-margin">
            <EditOutlinedIcon className='link-color' onClick={() => {
              setSelectedRole(role); setRoleModal(true);
            }} />
            <DeleteOutlineOutlinedIcon className='danger-color' onClick={() => {
              setIsOpen(true)
            }} />
          </Box>
          <>
            <Confirmation open={isOpen} setOpen={setIsOpen} msg="Are you sure you want to delete this Role" yesClick={() => { handleDelete(role.id); setIsOpen(false) }} />
          </>
        </Grid>
      </Grid>
    </>
  )
}


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    label: 'Name',
    numeric: false,
    disablePadding: false,
    id: 'name',
    sortable: true,
  },
  {
    label: 'Assiged Permissions',
    numeric: false,
    disablePadding: false,
    id: 'permission',
    sortable: false,
  },

  {
    label: 'Actions',
    numeric: false,
    disablePadding: false,
    id: 'actions',
    sortable: false,
  },
];

function EnhancedTableHead(props) {
  const { setOrdering, orderingState, setOrderingState } =
    props;

  const createSortHandler = (property) => (event) => {
    const orderData = orderingState
    const exists = orderData?.find((item) => item.id === property);
    const updated = (() => {

      if (exists) {
        return orderData.map((item) =>
          item.id === property
            ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
            : item
        );
      } else {
        return [...orderData, { id: property, order: "asc" }];
      }
    })();
    setOrderingState(updated)

  };

  React.useEffect(() => {
    const ordering = orderingState.map((item) => {
      return item.order === "asc" ? item.id : "-" + item.id;
    });
    if (ordering?.length) {
      setOrdering(ordering.join(","));
    }
    console.log("orderingState", orderingState);

  }, [orderingState]);

  const removeFilter = (property) => {
    const data = orderingState.filter((item) => item.id !== property)
    setOrderingState(data)
  }

  return (
    <TableHead>
      {/* <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            className='font-weight'
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                color="secondary"
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={{ display: 'none' }}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow> */}
      <TableRow>
        {headCells.map((headCell) => {
          const key = headCell.id;
          const sortObj = orderingState.find((item) => item.id === key);
          const isSorted = !!sortObj;
          const sortDirection = sortObj?.order || "asc";

          return (<TableCell
            className="font-weight"
            key={key}
            align={headCell.numeric ? "left" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={isSorted ? sortDirection : false}
          >
            {headCell.sortable ? <TableSortLabel
              active={isSorted}
              direction={sortDirection}
              onClick={createSortHandler(key)}
              color="secondary"
              hideSortIcon={false}
            >
              {headCell.label}
              {isSorted && (
                <Box component="span" sx={visuallyHidden}>
                  {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              )}
              {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
            </TableSortLabel> : headCell.label}
          </TableCell>)
        })}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
function EnhancedTableToolbar(props) {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const { numSelected, resetTrigger, setPage, setResetTrigger, setSelectedRole, page, getRoles } = props;

  // React.useEffect(() => {
  //   dispatch(fetchRoleData({queryString: `?ordering=${ordering}` }))
  //   // dispatch(fetchPermissions())
  // }, [ordering])

  return (
    <>

      <RoleForm roleModal={open} setPage={setPage} setRoleModal={setOpen} {...{ page, getRoles }} title="Create Role" />
      <Toolbar
        className='main-list-toolbar'
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Roles
        </Typography>

        <Tooltip title="Create">
          <Button variant="contained" onClick={() => { setOpen(true); setSelectedRole(null); setResetTrigger(!resetTrigger) }}>Create Role</Button>
        </Tooltip>
      </Toolbar>
    </>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function RoleManage() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const userPermission = useSelector((state => state.userReducer.userPermission))
  const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
  const [roleModal, setRoleModal] = React.useState(false);
  const [selectedRole, setSelectedRole] = React.useState({});
  const [resetTrigger, setResetTrigger] = React.useState(false);
  const rolesList = useSelector((state) => state.roleReducer.rolesData)
  const count = useSelector((state) => state.roleReducer.count)
  const [expandedRows, setExpandedRows] = React.useState({});
  const [queryString, setQueryString] = React.useState("");
  const [ordering, setOrdering] = React.useState();
  const [orderingState, setOrderingState] = React.useState([])
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.roleReducer.loading)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const toggleExpanded = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(() => {
    const rowData = rolesList?.map((ele) => createData(ele.id, ele.name, ele?.permissions?.assigned_permissions, <RoleActions {...{ getRoles, setPage, setRoleModal, setSelectedRole }} role={ele} />))
    setRows(rowData)
  }, [rolesList])

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // const visibleRows = React.useMemo(() => {
  //   return [...rows]
  //   // .sort(getComparator(order, orderBy))
  //   // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  // }, [rows]);

  function getPermissionLabel(permissions) {
    const allPermissions = MODULE_PERMISSIONS;

    if (permissions.length === allPermissions.length &&
      allPermissions.every(p => permissions.includes(p))) {
      return FULL_ACCESS;
    }

    if (permissions.includes(MODULE_CHANGE) && permissions.includes(MODULE_ADD)) {
      return ADD_UPDATE;
    }

    if (permissions.includes(MODULE_VIEW) && permissions.length === 1) {
      return VIEW_ONLY;
    }

    return permissions.join(', ').replace('change', 'Update');
  }

  React.useEffect(() => {
    dispatch(fetchRoleData({ queryString: `?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}` }))
    setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}`)
  }, [ordering, page, rowsPerPage])

  const getRoles = () => {
    dispatch(fetchRoleData({ queryString }))
  }


  return (
    <Box className='w-100'>
      <RoleForm {...{ getRoles, page, setPage, roleModal, setRoleModal, selectedRole, resetTrigger }} title="Edit Role" />
      <Paper className="w-100 mb-2" >
        <EnhancedTableToolbar numSelected={selected.length} {...{ getRoles, page, setPage, resetTrigger, setResetTrigger, setSelectedRole }} />
        {loading && <LinearProgress />}
        <TableContainer className='postion-relative'>
          <Table
            container
            className='min-width-750'
            aria-labelledby="tableTitle"
            size={'small'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              orderingState={orderingState}
              setOrderingState={setOrderingState}
              setOrdering={setOrdering}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {/* <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key="superAdmin"
                className='cursor-pointer'
              >
                <TableCell align="left" >Super Admin</TableCell>
                <TableCell align="left" className='role-chip'>
                  <Stack spacing={1} className='table-margin'>
                    <Stack direction="row" spacing={1}>
                      <Chip key="rsuperAdminPermission" className='role-permission' label="Full Access" />
                    </Stack>
                  </Stack>
                </TableCell>
                <TableCell align="left"></TableCell>
              </TableRow> */}
              {rows?.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    className='cursor-pointer'
                  >
                    <TableCell align="left">{capitalizeWords(row.name)}</TableCell>
                    {/* <TableCell align="left" className='role-chip'>
                      <Stack spacing={1}>
                        <Stack direction="row" spacing={1}>
                          {row?.permissions?.length ? (
                            row?.permissions?.map((permissionItem, ind) => {

                              return permissionItem?.permissions?.length ? <Chip key={ind} className='role-permission' label={permissionItem.display_name + " : " + getPermissionLabel(permissionItem?.permissions)} />
                                : (
                                  <Chip key={permissionItem.model_name} className='role-permission' label="N/A" />
                                );
                            })
                          ) : (
                            <>N/A</>
                          )}
                        </Stack>
                      </Stack>
                    </TableCell> */}
                    <TableCell align="left" className="role-chip">
                      <Stack spacing={1}>
                        <Stack direction="row" className='mt-1' flexWrap="wrap" gap={1}>
                          {row?.permissions?.length ? (
                            <>
                              {(expandedRows[row.id] ? row.permissions : row.permissions.slice(0, 3)).map((permissionItem, ind) =>
                                permissionItem?.permissions?.length ? (
                                  // <Chip
                                  //   key={ind}
                                  //   className="role-permission"
                                  //   label={`${permissionItem.display_name} : ${getPermissionLabel(permissionItem?.permissions)}`}
                                  // />
                                  <Box key={ind} display="flex" alignItems="center" gap={1}>
                                    <span>{permissionItem.display_name}:</span>
                                    {/* <span>:</span> */}
                                    <Typography variant='body2' color={"primary"}>{getPermissionLabel(permissionItem?.permissions)}</Typography>
                                    <span style={{ margin: '0 8px' }}>|</span>
                                  </Box>
                                ) : (
                                  <Typography variant='body2'>N/A</Typography>
                                  // <Chip key={permissionItem.model_name} className="role-permission" label="N/A" />
                                )
                              )}
                              {row?.permissions?.length > 3 && (
                                <BasicPopover length={row?.permissions?.length - 3}>
                                  <List disablePadding dense className='location-list'>
                                    {row.permissions.slice(3).map((permissionItem, index) => (
                                      <ListItem key={index} disableGutters>
                                        <ListItemText
                                          primary={
                                            <Box key={index} display="flex" alignItems="center" gap={1}>
                                            <span>{index+1}. {permissionItem.display_name}:</span>
                                            {/* <span>:</span> */}
                                            <Typography variant='body2' color={"primary"}>{getPermissionLabel(permissionItem?.permissions)}</Typography>
                                         
                                          </Box>
                                            // <Typography color='primary' variant='body2'>{`${index + 1}. ${permissionItem.display_name} : ${getPermissionLabel(permissionItem?.permissions)}`}</Typography>
                                          }
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                </BasicPopover>
                              )}

                              {/* {row?.permissions?.length > 3 && (
                                <div className='custom-read-more'>
                                  <Button
                                    size="small"
                                    sx={{ textDecoration: 'underline', textTransform: 'none' }}
                                    className="text-underline"
                                    onClick={() => toggleExpanded(row.id)}
                                  >
                                    {expandedRows[row.id] ? "Read Less" : "Read More"}
                                  </Button>
                                </div>
                              )} */}
                            </>)
                            : (
                              <>N/A</>
                            )}

                        </Stack>
                      </Stack>
                    </TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {!rolesList?.length && !loading && <NoData></NoData>}
          {/* {!visibleRows?.length && <Loader className='table-loader' />} */}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          className='table-pagination'
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
